export default {
    welcome: "Bem-vindo(a)",
    "customer-gallery": "Galeria de Clientes",
    "need-inspiration": "Precisa de inspiração?",
    "get-inspired": "Fique inspirado",
    "get-inspired-desc": "De infográficos e quizzes para micro-sites e vídeos, nós temos exemplos para todas as indústrias e vários tipos de conteúdo que irão inspirar sua próxima idéia.",
    "gtn-desc": "Desenvolva sua carreira enquanto faz conteúdo de marketing para as melhores marcas da Rock Content!",
    "talent-blog-desc": "Um lugar onde você pode encontrar conteúdo especializado que levará sua carreira para o próximo nível.",
    "community-space-desc": "Comunidade freelancer exclusiva da Rock Content.",
    "help-rock-content": "Suporte da Rock Content.",
    "easy-access": "Acesso fácil",
    "btn-open": "Abrir",
    "rock-university": {
        "highlighted-desc": "Melhore suas habilidades de marketing!",
        desc: "Aprenda com os especialistas do setor sobre experiências de conteúdo e estratégia e execução de conteúdo interativo.",
        "call-to-action": "Tornar-se um especialista!",
    },
    "content-not-found": "Conteúdo não encontrado",
    products: {
        studio: "Colaboração de marketing para equipes e agências de marketing.",
        "studio 3": "Colaboração de marketing para equipes e agências de marketing.",
        "studio 2.0": "Colaboração de marketing para equipes e agências de marketing.",
        "studio 3.0": "Colaboração de marketing para equipes e agências de marketing.",
        ion: "Crie experiências interativas sem codificação.",
        live: "Maximize os resultados de suas vidas com experiências ao vivo feitas sob medida.",
        stage: "Hospedagem gerenciada do Wordpress e hubs de conteúdo otimizados.",
        iclips: "",
        "global talent network": "Desenvolva sua carreira enquanto faz conteúdo de marketing para as melhores marcas do Rock Content!",
        "rock university": "",
        "stage legacy": "Hospedagem gerenciada do Wordpress e hubs de conteúdo otimizados.",
    },
};
